<div class="modal-content">
  <div class="modal-header">
    <h5 class="font-bold text-xl" i18n>Aktivacija modula</h5>
  </div>

  <div class="modal-body" *ngIf="!isLoading">
    <div class="mb-4">
      <h6 class="font-bold text-lg mb-2">{{ modulePackage.name }}</h6>
      <p class="text-gray-600 mb-3" *ngIf="modulePackage.description">
        {{ modulePackage.description }}
      </p>
    </div>

    <!-- Billing Period Toggle (only when the module offers both monthly and yearly) -->
    <div class="mb-4" *ngIf="hasBothPeriods && !modulePackage.isFree">
      <div class="text-sm font-bold mb-2" i18n>Naročnina:</div>
      <div class="grid grid-cols-2 gap-2">
        <button type="button"
                class="rounded border p-2 text-center"
                [ngClass]="selectedPeriod === 'monthly' ? 'border-primary bg-blue-50' : 'border-grayHover'"
                (click)="selectPeriod('monthly')">
          <div class="text-xs text-gray uppercase" i18n>Mesečno</div>
          <div class="font-bold text-primary">{{ modulePackage.priceMonthly!.toFixed(2) }} €<span class="text-xs text-gray font-normal" i18n>/mes</span></div>
        </button>
        <button type="button"
                class="rounded border p-2 text-center relative"
                [ngClass]="selectedPeriod === 'yearly' ? 'border-primary bg-blue-50' : 'border-grayHover'"
                (click)="selectPeriod('yearly')">
          <div class="text-xs text-gray uppercase" i18n>Letno</div>
          <div class="font-bold text-primary">{{ modulePackage.priceYearly!.toFixed(2) }} €<span class="text-xs text-gray font-normal" i18n>/leto</span></div>
          <div *ngIf="yearlySavings" class="text-xs text-green font-semibold mt-1">
            <span i18n>Prihraniš</span> {{ yearlySavings.toFixed(2) }} €
          </div>
        </button>
      </div>
    </div>

    <!-- Pricing Display -->
    <div class="border-t border-b border-gray-200 py-3 mb-4">
      <div class="flex justify-between items-start mb-2">
        <span class="text-gray-700" i18n>Cena:</span>
        <div class="text-right">
          <span class="font-bold text-blue-600">
            {{ displayPrice }}
          </span>
          <span *ngIf="displayPriceWithDdv" class="block text-xs text-gray-400">
            {{ displayPriceWithDdv }} <span i18n>z DDV</span>
          </span>
          <span *ngIf="!modulePackage.isFree" class="text-sm font-normal block text-gray-500">
            {{ displayBillingUnit }}
          </span>
          <span *ngIf="displayVolumeDeal" class="text-xs block text-gray-500 mt-1">
            {{ displayVolumeDeal }}
          </span>
        </div>
      </div>

      <div class="flex justify-between items-center" *ngIf="modulePackage.includedUnits">
        <span class="text-gray-700" i18n>Brezplačne enote:</span>
        <span class="font-semibold" *ngIf="freeUnitsRemaining !== null" i18n>še {{ freeUnitsRemaining }} od {{ freeUnitsLimit }}</span>
        <span class="font-semibold" *ngIf="freeUnitsRemaining === null">{{ modulePackage.includedUnits }}</span>
      </div>
    </div>

    <div class="alert alert-info mb-4" *ngIf="!modulePackage.isFree">
      <i class="fas fa-info-circle mr-2"></i>
      <ng-container *ngIf="isUsageBasedBilling; else flatSubscriptionNotice">
        <span *ngIf="!activePeriodIsYearly" i18n>
          Z aktivacijo modula se strinjate s pogoji uporabe.
          Zaračunavanje bo potekalo mesečno glede na vašo uporabo.
        </span>
        <span *ngIf="activePeriodIsYearly" i18n>
          Z aktivacijo modula se strinjate s pogoji uporabe.
          Zaračunavanje bo potekalo letno glede na vašo uporabo.
        </span>
      </ng-container>
      <ng-template #flatSubscriptionNotice>
        <span *ngIf="!(hasBothPeriods && selectedPeriod === 'yearly')" i18n>
          Z aktivacijo modula se strinjate s pogoji uporabe.
          Zaračunavanje bo potekalo mesečno, glede na izbrano obdobje naročnine.
        </span>
        <span *ngIf="hasBothPeriods && selectedPeriod === 'yearly'" i18n>
          Z aktivacijo modula se strinjate s pogoji uporabe.
          Zaračunavanje bo potekalo letno, glede na izbrano obdobje naročnine.
        </span>
      </ng-template>
    </div>

    <div class="mb-3" *ngIf="modulePackage.isFree">
      <div class="alert alert-success">
        <i class="fas fa-gift mr-2"></i>
        <span i18n>Ta modul je brezplačen!</span>
      </div>
    </div>

    <div class="mb-3" *ngIf="stripeDisabled && !modulePackage.isFree">
      <div class="alert alert-info">
        <i class="far fa-file-invoice mr-2"></i>
        <span i18n>Plačilo bo obračunano preko računa (brez kartice).</span>
      </div>
    </div>
  </div>

  <div class="modal-body text-center" *ngIf="isLoading">
    <app-content-shimmer height="100px"></app-content-shimmer>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()" [disabled]="disableButton">
      <span i18n>Prekliči</span>
    </button>
    <button type="button" class="btn btn-primary" (click)="activateModule()" [disabled]="disableButton">
      <span *ngIf="!isLoading" i18n>Aktiviraj modul</span>
      <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-spin mr-2"></i>
        <span i18n>Aktiviranje...</span>
      </span>
    </button>
  </div>
</div>

<!-- Payment Authorization Modal -->
<app-payment-authorization-modal
  *ngIf="showPaymentModal && stripeClientSecret && stripePublishableKey"
  [stripeClientSecret]="stripeClientSecret"
  [stripePublishableKey]="stripePublishableKey"
  [paymentType]="'module_package'"
  (paymentComplete)="onPaymentComplete()"
  (paymentCancelled)="onPaymentCancelled()"
  (paymentFailed)="onPaymentFailed($event)">
</app-payment-authorization-modal>
